import React, { useState, useEffect } from 'react';
import classNames from 'classnames';
import { languagesHelper as language } from '../../../../../util/languages';
import { useIntl } from '../../../../../util/reactIntl';

import { useConfiguration } from '../../../../../context/configurationContext';

import { FormattedMessage } from '../../../../../util/reactIntl';
import { getCountryFlagById } from '../../../../../util/getCountryFlag';

import { IconInfoMenu, TopbarSimplified, IconClose } from '../../../../../components';

import css from './CustomFullMenu.module.css';

const CustomFullMenu = props => {
  const { menuLinks, onLandscapesSection, rewildingLandscapesSection, listingsByFilters } = props;
  const intl = useIntl();

  const [open, setOpen] = useState(false);

  const config = useConfiguration();
  const locale = language.get();

  useEffect(() => {
    if (Object.keys(rewildingLandscapesSection).length === 0) {
      onLandscapesSection(locale);
    }
  }, [rewildingLandscapesSection]);

  const { listing } = config;
  const { listingFields } = listing;
  const countries =
    listingFields.find(item => item.key === 'linstingFieldId_country')?.enumOptions || [];

  const tourismLinks = menuLinks.filter(
    item => item.href === '/p/what-is-rewilding' || item.href === '/p/rewilding_tourism' || item.href === '/p/ecotourism' || item.href === '/p/wolf-watching-trips'
  );

  const aboutLinks = menuLinks.filter(
    item => item.href !== '/p/what-is-rewilding' && item.href !== '/p/rewilding_tourism' && item.href !== '/p/ecotourism' && item.href !== '/p/wolf-watching-trips'
  );

  const onCloseMenu = () => {
    setOpen(false);
  };

  const linstingFieldId_country = listingsByFilters?.linstingFieldId_country || {};
  const showCountries = countries.map(item => {
    const count = linstingFieldId_country?.[item.option];

    // Missing counts (other pages before fetch) must not fall through — `undefined < 1` is false.
    if (!(count > 0)) return null;

    return (
      <li key={item.option} onClick={() => setOpen(false)}>
        <a className={css.link} href={`/s?pub_linstingFieldId_country=${item.option}`}>
          <span className={css.flag}>{getCountryFlagById(item.option)}</span>
          {language.labelsTranslator(item.option, intl)}
        </a>
      </li>
    );
  });

  const showLandscapes =
    rewildingLandscapesSection.blocks && rewildingLandscapesSection.blocks.length > 0
      ? rewildingLandscapesSection.blocks.map((item, index) => {
          return (
            <li key={`${item.blockName}-${index}`} onClick={() => setOpen(false)}>
              <a className={css.link} href={item?.media?.link?.href || item?.callToAction?.href}>
                {intl.formatMessage({ id: `TopbarLink.${item.blockId}` })}
              </a>
            </li>
          );
        })
      : null;

  const showTourism = tourismLinks.map((item, index) => {
    return (
      <li key={`${item.href}-${index}`} onClick={() => setOpen(false)}>
        <a className={css.link} href={item.href}>
          {intl.formatMessage({ id: `TopbarLink.${item?.route?.params?.pageId}` })}
        </a>
      </li>
    );
  });

  const showAbout = aboutLinks.map((item, index) => {
    return (
      <li key={`${item.href}-${index}`} onClick={() => setOpen(false)}>
        <a className={css.link} href={item.href}>
          {intl.formatMessage({
            id: `TopbarLink.${item?.route?.params?.pageId || item?.route?.name}`,
          })}
        </a>
      </li>
    );
  });

  const contentStyles = classNames(css.content, { [css.contentOpen]: open });
  const columnsStyles = classNames(css.columns, { [css.columnsOpen]: open });

  return (
    <div className={css.wrapper}>
      <button className={css.buttonOpen} onClick={() => setOpen(true)}>
        <IconInfoMenu />
        <FormattedMessage id="TopbarDesktop.LinksMenu.info" />
      </button>
      <div className={contentStyles}>
        <div className={css.header}>
          <TopbarSimplified onCloseMenu={onCloseMenu} />
          <button className={css.buttonClose} onClick={() => setOpen(false)}>
            <IconClose rootClassName={css.closeIcon} />
          </button>
        </div>
        <div className={columnsStyles}>
          <div className={css.column}>
            <p className={css.title}>
              <FormattedMessage id="TopbarDesktop.LinksMenu.destinations" />
            </p>
            <ul className={css.links}>{showCountries}</ul>
          </div>

          <div className={css.column}>
            <p className={css.title}>
              <FormattedMessage id="TopbarDesktop.LinksMenu.landscapes" />
            </p>
            <ul className={css.links}>
            {showLandscapes}
            {/* hardcode or now */}
            <li key={"Oder Delta"} onClick={() => setOpen(false)}>
              <a className={css.link} href={"/p/landscape-oder-delta"}>
                {intl.formatMessage({ id: `TopbarLink.oder-delta` })}
              </a>
            </li>
            </ul>
          </div>

          <div className={css.column}>
            <p className={css.title}>
              <FormattedMessage id="TopbarDesktop.LinksMenu.tourism" />
            </p>
            <ul className={css.links}>{showTourism}</ul>
          </div>

          <div className={css.column}>
            <p className={css.title}>
              <FormattedMessage id="TopbarDesktop.LinksMenu.about" />
            </p>
            <ul className={css.links}>{showAbout}</ul>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CustomFullMenu;
